import React from 'react';
import { pathObject } from '../../../data/pathObject';

function CurrentPath(props) {
	const path = props.path;
	return (
		<>
			<div className="cp-container">
				<span className="dashboard-title">Tableau de bord</span>
				<span className="path-chevron"></span>
				<span className="path-name">{pathObject[path.slice(1)]}</span>
			</div>
		</>
	);
}

export default CurrentPath;
